module.exports = __webpack_public_path__ + "static/Feature4-c9f317757149955fbb318015382fa8c5.jpg";